import { useState } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideFaq, FaqFormData } from './types'
import { AiInstructionFormData } from '../common/types'

export const useFaqRegenerate = () => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isRegenerating, setIsRegenerating] = useState(false)

  const regenerateFaq = async (
    id: string,
    aiInstruction: string,
    setSlideFaq: (slideFaq: SlideFaq) => void,
    resetAiForm: (data: AiInstructionFormData) => void,
    resetForm: (data: FaqFormData) => void
  ) => {
    if (!aiInstruction.trim() || !id) return

    setIsRegenerating(true)

    try {
      const response = await apiClient.business.slideFaqRegenerateCreate({
        businessIdeaId: id,
        aiInstruction: aiInstruction,
      })

      if (response.data?.faq) {
        setSlideFaq(response.data.faq)
        resetAiForm({ aiInstruction: '' })
        showSnackBar(['FAQ・懸念点まとめのAI再生成が完了しました'], 'success', null) // 自動で消えない

        try {
          resetForm({
            concerns: JSON.parse(response.data.faq.concerns || '[]'),
            faqs: JSON.parse(response.data.faq.faqs || '[]'),
          })
        } catch (parseError) {
          console.error('JSONパースエラー:', parseError)
          showSnackBar(['FAQ・懸念点まとめのデータの読み込みに失敗しました。'], 'error', null) // 自動で消えない
        }
      }
    } catch (e) {
      console.error('FAQ・懸念点まとめのAI再生成に失敗しました:', e)
      handleError(e as ApiErrorResponse, (messages, severity) => {
        showSnackBar(messages, severity, null) // 自動で消えない
      })
    } finally {
      setIsRegenerating(false)
    }
  }

  return {
    isRegenerating,
    regenerateFaq,
  }
}
